import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Heading, Paragraph } from '@digdir/designsystemet-react';

import { ButtonWrapper } from '../../pages/solceller/form/components/styledComponents';

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesDialog: FC<Props> = ({ isOpen, onCancel, onConfirm }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.common' });

  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <Dialog.Block>
        <Heading level={1} data-size="sm">
          {t('usavedChangesDialog.title')}
        </Heading>
        <Paragraph>{t('usavedChangesDialog.info')}</Paragraph>
        <ButtonWrapper>
          <Button variant="primary" onClick={onCancel}>
            {t('cancel')}
          </Button>

          <Button variant="secondary" onClick={onConfirm}>
            {t('usavedChangesDialog.confirm')}
          </Button>
        </ButtonWrapper>
      </Dialog.Block>
    </Dialog>
  );
};
